// Nav transparency on scroll
const nav = document.querySelector('.site-nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 60);
  }, { passive: true });
}

// Scroll reveal
const io = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  });
}, { threshold: 0.07 });
document.querySelectorAll('.rev').forEach(el => io.observe(el));

// Live cart count
function refreshCartCount() {
  fetch('/cart.js').then(r => r.json()).then(data => {
    document.querySelectorAll('.js-cart-count').forEach(el => {
      el.textContent = `[ ${data.item_count} ]`;
    });
  });
}
refreshCartCount();

// AJAX add to cart
function addToCart(variantId, btn) {
  if (!btn) return;
  const original = btn.textContent;
  btn.textContent = 'Adding...';
  btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(r => r.json())
  .then(() => {
    btn.textContent = 'Added';
    refreshCartCount();
    setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 2000);
  })
  .catch(() => { btn.textContent = original; btn.disabled = false; });
}

// Product page add to cart
const addForm = document.querySelector('.js-add-form');
if (addForm) {
  addForm.addEventListener('submit', e => {
    e.preventDefault();
    const btn = addForm.querySelector('.product-page__add');
    const id  = addForm.querySelector('[name="id"]').value;
    addToCart(parseInt(id), btn);
  });
}
